import React from "react";
import { Search } from "react-bootstrap-icons";

// SCSS
import "./SearchBar.scss";

const SearchBar = ({ value, onChange, placeholder }) => {
  // Search
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <form onSubmit={handleSubmit} className="SearchBar">
      <label htmlFor="search" className="SearchBar__Label">
        Search
      </label>
      <input
        type="text"
        value={value}
        autoComplete="off"
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || "Search…"}
        id="search"
        className="SearchBar__Input"
      />
      <button type="submit" className="SearchBar__Button">
        <Search />
      </button>
    </form>
  );
};

export default SearchBar;
